module.exports = __webpack_public_path__ + "files/a063da22077696cff8bd062cebff4861.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bold-webfont.woff2
 ** module id = 1013
 ** module chunks = 0
 **/